var render = function render(_c,_vm){return _c('span',{class:['badge', `is-${_vm.props.type}`],style:({backgroundColor: _vm.props.color})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }